import { Button } from "@coval/ui"
import { ArrowLeft, Check, CircleAlert, History, X } from "lucide-react"

import { reportClass } from "./ReportStyles"

/** The viewer's error, notice, and historical-revision banners. */
export function ReportMessages({
  error,
  notice,
  previewRevision,
  locked,
  onDismissError,
  onDismissNotice,
  onLatest,
  onRetryError,
}: {
  error: string
  notice: string
  /** The older revision on screen, or null on the latest one. */
  previewRevision: number | null
  locked: boolean
  onDismissError: () => void
  onDismissNotice: () => void
  onLatest: () => void
  /** Retries the failed initial load; set only while no notebook is installed. */
  onRetryError?: () => void
}) {
  return (
    <>
      {error && (
        <div className={reportClass("message error-message")} role="alert">
          <CircleAlert size={16} />
          <span>{error}</span>
          {onRetryError && (
            <Button
              variant="secondary"
              disabled={locked}
              onClick={onRetryError}
            >
              Try again
            </Button>
          )}
          <Button
            variant="ghost"
            icon
            tooltip="Dismiss error"
            onClick={onDismissError}
          >
            <X />
          </Button>
        </div>
      )}
      {notice && (
        <div className={reportClass("message notice-message")} role="status">
          <Check size={15} />
          <span>{notice}</span>
          <Button
            variant="ghost"
            icon
            tooltip="Dismiss notice"
            onClick={onDismissNotice}
          >
            <X />
          </Button>
        </div>
      )}
      {previewRevision !== null && (
        <div className={reportClass("message preview-message")}>
          <History size={15} />
          <span>
            Viewing revision {previewRevision}. The latest version is unchanged.
          </span>
          <Button variant="secondary" disabled={locked} onClick={onLatest}>
            <ArrowLeft />
            Latest
          </Button>
        </div>
      )}
    </>
  )
}
